(function (global) { // eslint-disable-line
    var pluginName = 'grNavigation';

    //  Constructor
    // --------------------------------------------------------------------------

    function grNavigation(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.trigger = this.selector.querySelector('[js-nav-trigger]');
        this.subNavs = this.selector.querySelectorAll('.header__primary-nav .hs-item-has-children');
        this.main = document.querySelector('.main');
        this.body = document.querySelector('body');
        this.initialScrollTop = this.getScrollTop();
        this.init();
    }

    //  Methods
    // --------------------------------------------------------------------------
    grNavigation.prototype.init = function init() {
        this.bindings();
        this.constructNav();
        this.mouse();

        var scrollTop = this.getScrollTop();
        if (global.methods.hasMinWidth()) {
            if (scrollTop > 200 && global.methods.hasMinWidth()) {
                global.methods.addAttributeValue(this.selector, 'js-header', 'is-sticky');
            }
        }
    }

    grNavigation.prototype.bindings = function bindings() {
        var instance = this;

        this.trigger.addEventListener('click', function(e) {
            e.preventDefault();
            global.methods.toggleAttributeValue(instance.selector, 'js-header', 'is-opened');
            global.methods.toggleAttributeValue(instance.main, 'js-header-state', 'is-opened');
        });


        this.main.addEventListener('click', function() {
            var state = document.querySelector('.main').getAttribute('js-header-state').indexOf('is-opened');
            if (state == 1) {
                global.methods.toggleAttributeValue(instance.selector, 'js-header', 'is-opened');
                global.methods.toggleAttributeValue(instance.main, 'js-header-state', 'is-opened');
            }
        });

        var ticking = false;

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    var scrollTop = instance.getScrollTop();
                    var delta = scrollTop - instance.initialScrollTop;
                    var state = global.methods.hasAttributeValue(instance.selector, 'js-header', 'is-sticky');

                    if (global.methods.hasMinWidth()) {
                        if (scrollTop > 200 && delta > 0 && !state) {
                            global.methods.addAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        }
                        else if (scrollTop < 200 && state) {
                            global.methods.addAttributeValue(instance.body, 'gr-handler', 'header-is-animate');

                            setTimeout(function() {
                                global.methods.removeAttributeValue(instance.selector, 'js-header', 'is-sticky');
                                global.methods.removeAttributeValue(instance.body, 'gr-handler', 'header-is-animate');
                            }, 200);
                        }

                        instance.initialScrollTop = scrollTop;
                    }
                    else {
                        if (scrollTop > 1 && !state) {
                            global.methods.addAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        }
                        else if (scrollTop <= 1 && state) {
                            global.methods.removeAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        }
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });
    }

    grNavigation.prototype.constructNav = function constructNav() {
        if (this.main) {
            this.main.setAttribute('js-header-state', '');
        }

        for (var i = 0, max = this.subNavs.length; i < max; i++) {
            var module = this.subNavs[i].querySelector('.hs-menu-children-wrapper a').getAttribute('href');
            this.subNavs[i].setAttribute('js-subNav-ready','');

            if (module.indexOf('#module-subnav-') !== -1) {
                var moduleId = module.replace('#module-subnav-', '');
                var subNav = document.querySelector('.module-subnav-' + moduleId);

                if (subNav) {
                    var cln = subNav.cloneNode(true);

                    this.subNavs[i].querySelector('.hs-menu-children-wrapper').innerHTML = '';
                    this.subNavs[i].querySelector('.hs-menu-children-wrapper').appendChild(cln);
                    this.subNavs[i].setAttribute('js-subNav','ready');
                }
            }

        }
    }

    grNavigation.prototype.mouse = function mouse() {
        var instance = this;
        var dropdownMenuTimer;

        for (var i = 0, max = this.subNavs.length; i < max; i++) {

            this.subNavs[i].addEventListener('mouseenter', function(e) {
                e.preventDefault();

                for (var x = 0, max = instance.subNavs.length; x < max; x++) {
                    global.methods.removeAttributeValue(instance.subNavs[x], 'js-subnav', 'is-active');
                }

                global.methods.addAttributeValue(this, 'js-subnav', 'is-active');
                clearTimeout(dropdownMenuTimer);
            });

            this.subNavs[i].addEventListener('mouseleave', function(e) {
                e.preventDefault();
                var _this = this;

                // edge fix to remove de hover state
                document.querySelector('.header__form [type=search]').blur();

                dropdownMenuTimer = setTimeout(function() {
                    global.methods.removeAttributeValue(_this, 'js-subnav', 'is-active');
                    // edge fix to remove de hover state
                    document.querySelector('.header__form [type=search]').focus();
                }, 400);
            });
        }
    }


    grNavigation.prototype.getScrollTop = function getScrollTop(){
        if (typeof pageYOffset!= 'undefined'){
            //most browsers except IE before #9
            return pageYOffset;
        }
        else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
        }
    }

    // Auto-Instantiation
    // --------------------------------------------------------------------------

    var all = {}, index;
    if (document.querySelectorAll('[js-header]').length) {
        window.groots.grNavigation = { instances: {} };
        all = document.querySelectorAll('[js-header]');
        index = -1;
        while (all[++index])
            global.grNavigation.instances[index] = new grNavigation(all[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grNavigation;
    // Export to Browser
    else global[pluginName] = grNavigation; // eslint-disable-line

}(window.groots));

